import {Action} from "redux";

export const CHANGE_LANGUAGE_CODE = Symbol("CHANGE_LANGUAGE");
export const CHANGE_GOOGLE_TAG_ID = Symbol("CHANGE_GOOGLE_TAG_ID");

export interface IAppState {
    languageCode: string;
    templateId?: number;
    googleTagId?: string;
}

export interface IAppReducerAction extends Action<symbol> {
    languageCode?: string;
    templateId?: number;
    googleTagId?: string;
}

const initialState: IAppState = {
    languageCode: "en",
    templateId: undefined,
    googleTagId: undefined
};

export default function AppReducer(state: IAppState = initialState, action: IAppReducerAction): IAppState {
    switch(action.type) {
        case CHANGE_LANGUAGE_CODE:
            return {
                ...state,
                languageCode: action.languageCode!,
                templateId: action.templateId ? action.templateId : state.templateId
            };
        case CHANGE_GOOGLE_TAG_ID:
            return {
                ...state,
                googleTagId: action.googleTagId
            };
        default:
            return state;
    }
}